import FacebookPlugin from './FacebookPlugin'

export default FacebookPlugin